import styled from "@emotion/styled";

import {
  getCardBaseStyles,
  getCardCenterStyles,
  getCardClickableStyles,
  getCardStickyStyles,
} from "./card-styles";
import type { StyledCardProps } from "./types";

export const StyledCard = styled.div<StyledCardProps>`
  position: relative;
  display: block;
  transition:
    box-shadow 0.2s ease,
    transform 0.1s ease,
    background-color 0.2s ease,
    border-color 0.2s ease;

  /* Apply base styles from styleProps */
  ${({ $styleProps }) => getCardBaseStyles($styleProps)}

  /* Apply clickable styles */
  ${({ $clickable = false, $styleProps }) =>
    getCardClickableStyles($clickable, $styleProps)}

  /* Apply overflow hidden */
  ${({ $overflowHidden }) => $overflowHidden && `overflow: hidden;`}

  /* Apply center styles */
  ${({ $center = false }) => getCardCenterStyles($center)}

  /* Apply sticky styles */
  ${({ $sticky = false, $styleProps }) =>
    getCardStickyStyles($sticky, $styleProps)}
`;
